module.exports = __webpack_public_path__ + "img/c3.fbe80c81.png";